{
    "convercusProgramId": "toom",
    "integration": "toom",
    "platform": "ios",
    "levelKey": "Top-Kunde",
    "appearance": {
        "balanceName": "Points",
        "icon": "https://firebasestorage.googleapis.com/v0/b/selfservice-convercus.appspot.com/o/toom%2Fheader-logo-on-light-transparent.png?alt=media",
        "passLogo": "https://firebasestorage.googleapis.com/v0/b/selfservice-convercus.appspot.com/o/toom%2Fheader-logo-on-light-transparent.png?alt=media",
        "bannerImage": "",
        "backgroundColor": "#000000",
        "foregroundColor": "#ffffff"
    },
    "scannableCode": {
        "type": "aztec",
        "previewMessage": "REWEDTP#2095055517755#VTKDEMO001#"
    },
    "mockPayload": {
        "name": "Anna Schmidt",
        "balance": 0,
        "tierStatus": "Top-Kunde",
        "vtkNumber": "VTKDEMO001",
        "bonusDisplay": "3%",
        "bonusLabel": "Bonus"
    },
    "apple": {
        "omitPointsAndBalanceSemantics": true,
        "headerFields": [
            {
                "key": "bonus",
                "label": "Bonus",
                "value": "3%"
            }
        ],
        "secondaryFields": [
            {
                "key": "name",
                "label": "Name",
                "value": "Anna Schmidt"
            },
            {
                "key": "aktualisiert",
                "label": "Aktualisiert",
                "value": "07.08.2026"
            }
        ],
        "auxiliaryFields": [
            {
                "key": "nr",
                "label": "Nr",
                "value": "VTKDEMO001"
            }
        ],
        "barcodeAltText": "\u200b"
    },
    "google": {
        "omitPrimaryLoyaltyPoints": true,
        "issuerName": "Vorteilskarte",
        "programName": "\u200b",
        "textModules": [
            {
                "id": "holder",
                "header": "Name",
                "body": "Anna Schmidt"
            },
            {
                "id": "nr",
                "header": "Nr",
                "body": "VTKDEMO001"
            },
            {
                "id": "bonus",
                "header": "Bonus",
                "body": "3%"
            },
            {
                "id": "updated",
                "header": "Aktualisiert",
                "body": "07.08.2026"
            }
        ],
        "barcodeAlternateText": "\u200b"
    }
}
